module.exports = __webpack_public_path__ + "static/media/green-grunge-paper-background.c4c2e8c1.jpg";